export default {
  // 示例翻译内容
  lang: '中文',
  zh:'简体中文',
  en:'English',
  ask:'咨询我们',
  menu: {
    menu1: '首页',
    menu2: '数智创新咨询',
    menu3: 'AI消费品工具平台',
    menu4: '关于我们',
    menu5: '蓝图洞见',
    menu1_1: '策略端 - 蓝图数智创新咨询',
    menu1_2: '工具端 - AI消费品工具平台',
    menu1_3: '关于我们',
    submenu2_1: 'Why？第一阶段：舆情探针',
    submenu2_1_1: '热点雷达',
    submenu2_1_2: '趋势风口',
    submenu2_1_3: '竞争周报',
    submenu2_1_4: '品牌声誉',
    submenu2_1_5: '产品表现',
    submenu2_2: 'What？第二阶段：需求洞察',
    submenu2_2_1: '圈层画像',
    submenu2_2_2: '需求深挖',
    submenu2_2_3: '痛点锁定',
    submenu2_2_4: '购买决策',
    submenu2_2_5: '卖点验证',
    submenu2_2_6: '跨界拓品',
    submenu2_3: 'How？第三阶段：产品蓝图',
    submenu2_3_1: '新品定位',
    submenu2_3_2: '造型计算',
    submenu2_3_3: '功能计算',
    submenu2_3_4: '互动计算',
    submenu2_3_5: '柔性成本',
    submenu2_3_6: '定价策略',
    submenu2_3_7: '渠道优化',
    submenu2_3_8: '营销突破',
    submenu2_3_9: '生命周期',
    submenu3_1: 'Deeper - AI产品智能决策工作流平台',
    submenu3_2: 'StellarCore星核 - 大数据AI消费品趋势引擎',
    submenu5_1: '蓝图趋势',
    submenu5_1_1: '星核周报',
    submenu5_1_2: '星核月报',
    submenu5_1_3: '蓝图方法论',
    submenu5_1_4: '蓝图案例',
    submenu5_2: '星核 DI',
    submenu5_2_1: '产品介绍',
    submenu5_2_2: '免费试用',
    submenu5_2_3: '行业定制',
    submenu5_3: '咨询合作',
    submenu5_3_1: '关于我们',
    submenu5_3_2: '蓝图招募',
    submenu5_3_3: '内容转载',
    submenu5_3_4: '咨询合作',
    submenu5_3_5: '建议反馈',
  },
  home: {
    p2_desc: '定制化解决企业的各类产品战略、产品策划问题，满足不同品类的增长需求。',
    circle1: '智能家居',
    circle2: '健康个护',
    circle3: '文娱快消',
    p3_tab1: '爆品创新',
    p3_tab2: '爆品优化',
    p3_tab3: '品牌升级',
    p7_text1: '我们提出产品逻辑变革的关键节点：',
    p7_text2: '未来，产品5.0时代！',
  },
  footer: {
    name: 'Lantu-Designing the Future',
    company: '企业名称：杭州深蓝图景数智科技有限公司',
    post: '邮政编码：310012',
    email: '邮箱：lantufuturedesign@gmail.com',
    address: '地址：浙江省杭州市西湖区黄龙未来中心',
    home: '蓝图首页',
    home1: '策略端-',
    home2: '蓝图数智创新咨询',
    home3: '工具端-',
    home4: 'AI消费品工具平台',
    home5: '关于我们',
    qa: '数智创新咨询',
    qa1: 'Why?',
    qa2: '第一阶段：舆情探针',
    qa3: 'What？',
    qa4: '第二阶段：需求洞察',
    qa5: 'How？',
    qa6: '第三阶段：产品蓝图',
    tool: 'AI消费品工具平台',
    tool1: 'Deeper-',
    tool2: 'AI产品智能决策工作流平台',
    tool3: 'StellarCore星核-',
    tool4: '大数据AI消费品趋势引擎',
    clear: '蓝图洞见',
    clear1: '蓝图趋势',
    clear2: '星核 DI',
    clear3: '咨询合作',
    contact: '联系我们',
  },
  tool: {
    logic: '逻辑',
    value: '价值',
    logic1: '将社会舆情榜单与行业特性结合，结合热点与品类知识图谱创意联想，不止是呈现热点，而是精准挖掘与目标行业/品类直接相关的价值机会。',
    value1: '避免企业陷入“敏感性低”、“错失机会”、“无效热点追踪”，直接输出可落地的品类机会点。',
    logic2: '锚定行业重点关键词，追踪风口趋势，建模窗口生命周期，分析如新兴技术、设计风格、参数取向、价格带等的多维度趋势变化。',
    value2: '提供季度性风口先机，预判趋势窗口，助您在产品规划阶段抢占先机。',
    logic3: '实时监控竞品的产品更新、专利布局、宣传策略、市场动态等的一手动态信息。',
    value3: '让企业快速响应竞品动作，把控行业最新动态，避免市场被动。',
    logic4: '分析多平台消费者舆情声音，绘制品牌形象认知图谱，挖掘消费者心智定位，并做好风险防范及危机预警。',
    value4: '帮助企业校准品牌形象，寻找或强化消费者心智定位。',
    logic5: '将用户购后的好评与吐槽，经过系统性模型筛查，转化为细颗粒度、具体、清晰的产品优化指令，指导产品完成精准迭代研发。',
    value5: '让用户反馈直接指导产品迭代，闭环市场诉求，避免研发方向偏差。',
    logic6: '基于NLP分析目标圈层消费模式与心理，多维建模，绘制目标人群24小时生活圈，深入刻画针对性人群/圈层的全方位生活、消费、认知偏好图谱。',
    value6: '精准定位产品的合理目标用户与消费场景，提供全方位“人-物-场”画像。',
    logic7: '从社交媒体和电商评论的海量信息中提炼市场现有的隐性需求，通过LLM解析、时序趋势分析与多维筛查，识别市场的增量诉求与价值蓝海。',
    value7: '定位产品方向，挖掘增量需求。',
    logic8: '通过痛点“舆情声量”与“消费者痛度”优先级排序，基于痛点攻克回报率计算，帮助企业锁定资源，瞄准高回报核心痛点。',
    value8: '识别高痛感关键问题，集中资源、攻克关键，避免研发资源分散。',
    logic9: '拆解消费者“认知→兴趣→决策→购买→返评”全链路表现，基于跨平台漏斗模型量化链路指标，捕捉用户在路径中的关键节点转化率与流失率，生成降损方案，拉升消费者购买决策转化率。',
    value9: '提供全链路内容/渠道/时间/形式，综合核查与升级架构，持续降低购买路径损耗。',
    logic10: '在产品上市前，大数据评估卖点 “需求性-竞争性-趋势性”，多维预测建模，生成卖点“风险-信心指数”预验报表一览。',
    value10: '避免推出 “伪卖点”产品，降低市场风险。',
    logic11: '基于自然联想与消费者舆情语义共现技术，结合品牌优势、品类联想与跨界类比，系统性规划品牌的新品类可拓展图谱。',
    value11: '稳健拓展品牌新生态，增强跨界成功率。',
    logic12: '数据抓取市场空白位与竞争格局，制定差异化新品切入策略，包涵价值主张、目标客群、场景生态、价格带、进入配置等关键定位战略要素。',
    value12: '确保产品切入点精准，避免市场同质化。',
    logic13: '拆解爆品造型设计要素，基于市场反馈提炼高价值设计特征，提供包括风格、CMF、组件配置、IP等的全方位造型计算，生成潜力造型方案。',
    value13: '市场数据支撑造型设计，打造产品颜值吸引力。',
    logic14: '平衡市场需求与研发成本，识别消费者高关注、高黏性核心功能，高效配置旗舰、高端、中端、入门等不同等级功能盘。',
    value14: '避免功能堆砌、资源浪费，聚焦核心功能卖点。',
    logic15: '针对强互动品类，构建体验价值模型，抓取用户诉求与情感投射规划体验设计要素，构建从认知塑造、体验触点、交互逻辑，到使用旅程的完整方案。',
    value15: '通过玩法体验深入构建消费者联结，增强产品黏性。',
    logic16: '根据产品造型、功能、互动配置多因子量化建模，完成模块化成本单生成，提供清晰、透明的成本报告柔性生成。',
    value16: '柔性供应、灵活降本、快速报价，提升产品竞争力。',
    logic17: '扫描市场意愿与定价区间，制定合理定价策略，提供市场、季节、地域性动态定价套餐，挖掘合理溢价，打造产品价值。\n',
    value17: '价格策略优化，不错失产品合理溢价空间。',
    logic18: '建立目标群体跨平台触达偏好与心智链路模型，追踪爆品的跨平台消费决策、下单路线，规划产品从品牌到用户的最佳触达路径。',
    value18: '帮助企业集中资源选定高转化渠道，确保产品高效触达目标用户。',
    logic19: '基于社媒大数据，提炼高效营销要素，包涵营销概念红蓝榜、高价值种草方案、多平台文案生成，做好周期适配、平台适配，全面放大营销成效。',
    value19: '精准认知定位，放大声量，差异化快速破圈。',
    logic20: '多因子品类生命周期建模，全方位节奏规划与路径预知，规划产品从上市、迭代到退市的全生命周期策略，提供关键节点节奏与运营策略方案。',
    value20: '确保产品在各阶段的高效运营，最大化市场生命价值。',
  },
  clear: {
    p1: {
      subTitle: '大数据AI + 增长洞察方法论 = 共创消费品有效创新',
      tab1: '星核周报',
      tab2: '星核月报',
      tab3: '蓝图方法论',
      tab4: '蓝图案例',
    },
    p2: {
      subTitle: '新一代 大数据 垂类AI消费品趋势引擎',
      tab1: '产品介绍',
      tab2: '免费试用',
      tab3: '行业定制',
     },
    p3: {
      subTitle: '蓝图重视「数据、技术、效果」，诚启合作！',
      tab1: '关于我们',
      tab2: '蓝图招募',
      tab3: '内容转载',
      tab4: '咨询合作',
      tab5: '建议反馈',
    },
  }
}
